import { combineReducers } from '@reduxjs/toolkit';
import data from './dataSlice';
import state from './stateSlice';

const orderManagementReducer = combineReducers({
  state,
  data,
});

export default orderManagementReducer;
